import { Injectable } from '@angular/core';
import DOMPurify, { Config } from 'dompurify';

@Injectable({ providedIn: 'root' })
export class SanitizeService {

    constructor() {
        DOMPurify.setConfig({
            ALLOWED_TAGS:  ['b','i','em','strong','a','p','ul','li','br'],
            ALLOWED_ATTR:  ['href','title','target']
        });
    }

    /**
     * Säubert unsauberes HTML.
     * @param dirty unsicherer HTML-String
     * @param config optionale Overrides für DOMPurify
     */
    sanitize(dirty: string, config?: Config): string {
        return DOMPurify.sanitize(dirty, config);
    }

}